<!-- Main Menu/Desktop - Figma node 25769:268039 -->
<header
  class="hidden md:flex md:sticky md:top-0 z-20 h-[66px] w-full shrink-0 items-center justify-between border-b border-solid border-[#DDDDDD] bg-white px-[132px]"
>
  <div class="flex h-full items-center gap-9">
    <button
      type="button"
      class="flex h-7 w-7 items-center justify-center"
      aria-label="IVY Health Assistant"
      (click)="select('health-assistant')"
    >
      <svg
        class="block h-7 w-7"
        width="28"
        height="28"
        viewBox="0 0 28 28.0004"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.40723 0.00334722C12.0485 -0.0647209 14.5362 0.907251 16.4277 2.74749C18.0807 4.36623 19.086 6.46175 19.3076 8.72796C24.1303 9.29026 27.9307 13.3117 27.999 18.185C28.0331 20.809 27.0449 23.2628 25.2217 25.1371C23.3983 26.9774 20.9442 28.0003 18.3369 28.0004H3.86816C1.7381 28.0003 1.05229e-05 26.2622 0 24.1323V9.85296C0 4.57057 4.22662 0.156707 9.40723 0.00334722ZM9.49219 3.03655C5.93063 3.13879 3.05096 6.18898 3.05078 9.83538V24.1157C3.05103 24.5755 3.42577 24.9506 3.88574 24.9506H18.3369C20.1262 24.9505 21.8132 24.251 23.0742 22.9731C24.3351 21.6951 24.9995 20.0082 24.9824 18.2192C24.9328 15.0803 22.625 12.47 19.5957 11.8324C18.9927 11.6779 17.2508 11.6208 15.8232 11.7992H15.8223C13.278 12.0561 11.5718 12.7492 10.3105 14.0102C8.77681 15.5438 8.99773 17.1633 9.91797 18.0834C10.3951 18.5604 11.0088 18.8158 11.6562 18.8158C12.4402 18.8158 13.2414 18.4236 13.9912 17.6908C15.036 16.6595 15.6882 15.3012 16.0283 13.4184C17.6267 13.3266 18.8551 13.6916 19.0791 13.7631C18.7095 15.954 17.8964 18.1007 16.1553 19.8549C13.2753 22.7347 9.76436 22.2241 7.77051 20.2475C5.79372 18.2709 5.28309 14.7434 8.16309 11.8637C10.4466 9.58034 13.4971 8.89879 16.2578 8.71136C16.0533 7.28 15.371 5.95099 14.3145 4.91155C13.0534 3.70175 11.4179 3.03658 9.67969 3.03655H9.49219Z"
          fill="#32286C"
        />
      </svg>
    </button>
  </div>

  <nav class="flex items-center gap-7">
    <button
      type="button"
      class="text-base leading-normal text-black transition-opacity hover:opacity-70"
      [ngClass]="active === 'health-assistant' ? 'font-bold' : 'font-normal'"
      [attr.aria-current]="active === 'health-assistant' ? 'page' : null"
      (click)="select('health-assistant')"
    >
      Health Assistant
    </button>
    <button
      type="button"
      class="text-base leading-normal text-black transition-opacity hover:opacity-70"
      [ngClass]="active === 'my-data' ? 'font-bold' : 'font-normal'"
      [attr.aria-current]="active === 'my-data' ? 'page' : null"
      (click)="select('my-data')"
    >
      My data
    </button>
    <button
      type="button"
      class="text-base leading-normal text-black transition-opacity hover:opacity-70"
      [ngClass]="active === 'settings' ? 'font-bold' : 'font-normal'"
      [attr.aria-current]="active === 'settings' ? 'page' : null"
      (click)="select('settings')"
    >
      Settings
    </button>
  </nav>
</header>
